import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useTheme } from '../contexts/ThemeContext';

const { FiPlay, FiBook, FiTarget, FiDollarSign, FiLock } = FiIcons;

const Navigation = ({ activeFolder, setActiveFolder, courseData, isFolderUnlocked }) => {
  const { isDarkMode } = useTheme();
  const folderIcons = [FiPlay, FiBook, FiTarget, FiDollarSign];

  const handleFolderClick = (folderId, index) => {
    if (!isFolderUnlocked(index)) {
      alert('Completa la cartella precedente per sbloccare questa.');
      return;
    }
    setActiveFolder(folderId);
  };

  return (
    <div className="flex flex-wrap gap-3 justify-center mb-6">
      {courseData.map((folder, index) => {
        const isUnlocked = isFolderUnlocked(index);
        const isActive = activeFolder === folder.id;
        const IconComponent = folderIcons[index];

        return (
          <motion.button
            key={folder.id}
            className={`
              relative px-6 py-3 rounded-2xl font-semibold text-sm transition-all duration-300 
              flex items-center gap-2 overflow-hidden shadow-lg
              ${isActive 
                ? isDarkMode
                  ? 'bg-green-600 text-white shadow-green-500/25' 
                  : 'bg-success text-white shadow-success/25'
                : isUnlocked 
                  ? isDarkMode
                    ? 'bg-indigo-600 text-white hover:bg-indigo-500 hover:shadow-indigo-500/25' 
                    : 'bg-primary text-white hover:bg-primary-hover hover:shadow-primary/25'
                  : isDarkMode
                    ? 'bg-gray-600 text-gray-300 cursor-not-allowed'
                    : 'bg-gray-400 text-white cursor-not-allowed'
              }
            `}
            onClick={() => handleFolderClick(folder.id, index)}
            disabled={!isUnlocked}
            whileHover={isUnlocked ? { y: -3, scale: 1.02 } : {}}
            whileTap={isUnlocked ? { scale: 0.98 } : {}}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <SafeIcon 
              icon={isUnlocked ? IconComponent : FiLock} 
              className="text-lg" 
            />
            <span>{folder.title}</span>
            
            {isUnlocked && (
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full hover:translate-x-full transition-transform duration-500"></div>
            )}
          </motion.button>
        );
      })}
    </div>
  );
};

export default Navigation;